import { User } from './../interfaces/user';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  pexipdata = [];
  userdata: any;
  datosDeUsuario = new Subject();

  constructor(private http: HttpClient, private api: CloudFunctionsApiService) {}

  getUsers() {
    return this.api.snapshotList('/users');
  }

  getUsersNow() {
    return this.api.getCollection('/users');
  }

  getUserByUsuario(usuario) {
    return this.api.getCollection(`/users?username=${encodeURIComponent(usuario)}`);
  }

  getUserById(uid) {
    return this.api.snapshotList(`/users?uid=${encodeURIComponent(uid)}`);
  }

  getUserByIdNow(uid) {
    return this.api.getCollection(`/users?uid=${encodeURIComponent(uid)}`);
  }

  getUserByEmail(email) {
    return this.api.getCollection(`/users?email=${encodeURIComponent(email)}`);
  }

  getUserCodigo(codigo) {
    return this.api.getCollection(`/users?code=${encodeURIComponent(codigo)}`);
  }

  getUserColegio(colegio) {
    return this.api.getCollection(`/users?schoolId=${encodeURIComponent(colegio)}`);
  }

  getUserByColegioAndRole(colegio: string) {
    return this.api.getCollection(`/users?schoolId=${encodeURIComponent(colegio)}&role=student`);
  }

  getSupervisor(colegio) {
    return this.api.getCollection(`/users?schoolId=${encodeURIComponent(colegio)}&role=supervisor`);
  }

  createdUser(user: User) {
    return this.api.post('/users', user).toPromise();
  }

  editUser(user: any, uiduserdatabase) {
    return this.api.patch(`/users/${uiduserdatabase}`, user).toPromise();
  }

  searchUsers(clases) {
    return this.api.snapshotList(`/users?classes=${encodeURIComponent((clases || []).join(','))}`);
  }

  searchUsersClases(clases) {
    const batches = [];
    const batchSize = 10;
    for (let i = 0; i < clases.length; i += batchSize) {
      batches.push(clases.slice(i, i + batchSize));
    }

    if (batches.length === 0) {
      return of([]);
    }

    return combineLatest(
      batches.map((batch) =>
        this.api.snapshotList(`/users?classes=${encodeURIComponent(batch.join(','))}`)
      )
    ).pipe(map((results) => results.reduce((acc, cur) => acc.concat(cur), [])));
  }

  searchUsersCursos(cursos) {
    return this.api.snapshotList(`/users?courses=${encodeURIComponent((cursos || []).join(','))}`);
  }

  searchUsers_old(name) {
    return this.api.snapshotList(`/users?search=${encodeURIComponent(name)}`);
  }

  getPresence(uid: string) {
    return this.api.get(`/users/${uid}/presence`, null);
  }

  getUserinfodata() {
    return this.userdata;
  }

  setUserinfo(data) {
    this.userdata = data;
    this.datosDeUsuario.next(data);
  }

  mergeUserinfo(patch: any) {
    if (!this.userdata) {
      this.userdata = { ...patch };
      this.datosDeUsuario.next(this.userdata);
      return;
    }

    if (this.userdata?.payload?.doc?.data) {
      const current = this.userdata.payload.doc.data() || {};
      const merged = { ...current, ...patch };
      this.userdata = {
        ...this.userdata,
        payload: {
          ...this.userdata.payload,
          doc: {
            ...this.userdata.payload.doc,
            data: () => merged,
          },
        },
      };
    } else {
      this.userdata = { ...this.userdata, ...patch };
    }

    this.datosDeUsuario.next(this.userdata);
  }

  getUserinfo() {
    return this.datosDeUsuario;
  }

  getUsersbyClass(classuid) {
    return this.api.snapshotList(`/users?classId=${encodeURIComponent(classuid)}`);
  }

  getUsersbyColegio(colegioid) {
    return this.api.snapshotList(`/users?schoolId=${encodeURIComponent(colegioid)}`);
  }

  deleteUser(uid) {
    return this.api.delete(`/users/${uid}`).toPromise();
  }

  addUserToSchool(userId, schoolId) {
    return this.api.post(`/users/${userId}/schools/${schoolId}`).toPromise();
  }

  removeUserFromSchool(userId, schoolId) {
    return this.api.delete(`/users/${userId}/schools/${schoolId}`).toPromise();
  }

  addUserToCourse(userId, courseId) {
    return this.api.post(`/users/${userId}/courses/${courseId}`).toPromise();
  }

  removeUserFromCourse(userId, courseId) {
    return this.api.delete(`/users/${userId}/courses/${courseId}`).toPromise();
  }

  addUserToClass(userId, classId) {
    return this.api.post(`/users/${userId}/classes/${classId}`).toPromise();
  }

  removeUserFromClass(userId, classId) {
    return this.api.delete(`/users/${userId}/classes/${classId}`).toPromise();
  }
}
